import { useState } from "react";
import { Link } from "react-router-dom";
import { api, errText } from "../../lib/api";
import { Badge, DataTable, Select, shortDate, statusTone, useFilterOptions, useTable } from "./ui";

export default function ReviewsPage() {
  const table = useTable("/admin/tables/reviews");
  const options = useFilterOptions();
  const [msg, setMsg] = useState("");

  const act = async (fn, done) => {
    setMsg("");
    try {
      await fn();
      setMsg(done);
      table.reload();
    } catch (e) {
      setMsg(errText(e));
    }
  };

  const columns = [
    { key: "created_at", label: "Date", sortable: true, render: (r) => <span className="text-xs whitespace-nowrap">{shortDate((r.created_at || "").slice(0, 10))}</span> },
    { key: "rating", label: "Rating", sortable: true, render: (r) => <span className="tabular">{"★".repeat(r.rating)}</span> },
    { key: "shop_name", label: "Shop", render: (r) => (r.florist_id ? (
      <Link to={`/admin/florists/${r.florist_id}?tab=reviews`} className="underline decoration-brass underline-offset-2">{r.shop_name}</Link>
    ) : "—") },
    { key: "delivery_city", label: "City" },
    { key: "buyer_country", label: "From" },
    { key: "body", label: "Review", render: (r) => (
      <span className="text-xs">{r.title ? <b>{r.title} — </b> : null}{(r.body || "").slice(0, 160)}
        {r.florist_reply ? <span className="block text-muted mt-1">Reply: {r.florist_reply} ({r.reply_status})</span> : null}
      </span>
    ) },
    { key: "status", label: "Status", sortable: true, render: (r) => <Badge tone={statusTone(r.status)}>{(r.status || "").replace(/_/g, " ")}</Badge> },
    { key: "actions", label: "", render: (r) => (
      <span className="flex gap-1 whitespace-nowrap">
        {r.status !== "published" ? <button className="btn-ghost text-[11px]" data-testid={`publish-review-${r.id}`} onClick={() => act(() => api.post(`/admin/reviews/${r.id}/moderate`, { action: "publish" }), "Published.")}>Publish</button> : null}
        {r.status !== "hidden" ? <button className="btn-ghost text-[11px] text-danger" data-testid={`hide-review-${r.id}`} onClick={() => act(() => api.post(`/admin/reviews/${r.id}/moderate`, { action: "hide" }), "Hidden.")}>Hide</button> : null}
        {r.reply_status === "pending_review" ? <button className="btn-ghost text-[11px]" data-testid={`publish-reply-${r.id}`} onClick={() => act(() => api.post(`/admin/reviews/${r.id}/moderate`, { action: "publish_reply" }), "Reply published.")}>Publish reply</button> : null}
      </span>
    ) },
  ];

  return (
    <div className="space-y-3">
      {msg ? <p className="text-sm text-brass" data-testid="reviews-message">{msg}</p> : null}
      <DataTable table={table} columns={columns} testid="reviews-table" name="reviews"
                 searchPlaceholder="Words in a review…" empty="No review matches those filters."
                 filters={(
                   <>
                     <Select testid="reviews-filter-status" placeholder="Any status" value={table.params.status} onChange={(v) => table.set({ status: v })}
                             options={["pending_review", "published", "hidden"]} />
                     <Select testid="reviews-filter-rating" placeholder="Any rating" value={table.params.rating} onChange={(v) => table.set({ rating: v })}
                             options={[5, 4, 3, 2, 1].map((n) => ({ value: n, label: `${n} stars` }))} />
                     <Select testid="reviews-filter-shop" placeholder="Any shop" value={table.params.florist_id} onChange={(v) => table.set({ florist_id: v })}
                             options={options.florists.map((f) => ({ value: f.id, label: f.name }))} />
                   </>
                 )} />
    </div>
  );
}
